import { HintCard } from '@mgdlead/ui';

import { hintFor } from './hints';
import { useExperience } from './ExperienceProvider';

/**
 * A dica da tela atual (I2). Só aparece depois que as preferências chegaram — uma dica que
 * a pessoa já fechou não pode piscar na tela enquanto o servidor responde.
 */
export function ScreenHint({ screenId }: { screenId: string | undefined }) {
  const { isHintDismissed, dismissHint } = useExperience();
  const hint = hintFor(screenId);
  if (!hint || !screenId) return null;
  if (isHintDismissed(screenId) !== false) return null;

  return (
    <HintCard
      className="mb-4"
      {...(hint.title ? { title: hint.title } : {})}
      onDismiss={() => dismissHint(screenId)}
    >
      {hint.text}
    </HintCard>
  );
}
